module.exports = __webpack_public_path__ + "img/clos-menu.e488967e.svg";